module.exports = __webpack_public_path__ + "static/media/55-wine.f2f43939.jpg";